export default __webpack_public_path__ + "static/media/E4.0e7fdba1.mp3";